import type { Theme } from '@/contexts/ThemeContext/ThemeContext';

// Explicit dynamic imports rather than `import.meta.glob`, which breaks Cypress's non-module
// context. Lazy so the animation JSON is fetched only if the nudge fires.
const ATTENTION_LOADERS: Record<Theme, () => Promise<{ default: unknown }>> = {
    light: () => import('@/assets/lottie/zigbot-icon/ZigBotIcon_lightmode.json'),
    dark: () => import('@/assets/lottie/zigbot-icon/ZigBotIcon_darkmode.json'),
};

export const ZIGBOT_ATTENTION_PLAY_COUNT = 2;

export const ZIGBOT_ATTENTION_LOOP_MS = 2000;

export const loadZigBotAttention = async (theme: Theme): Promise<unknown | null> => {
    try {
        const module = await ATTENTION_LOADERS[theme]();
        return module.default ?? null;
    }
    catch {
        return null;
    }
};
